import { format } from "date-fns";
import UI_TYPES from "../types/UITypes";

const initialState = {
  sidebarOpen: true,
  currentDate: format(new Date(), "yyyy/MM/dd"),
};

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case UI_TYPES.TOGGLE_SIDEBAR_MENU:
      return {
        ...state,
        sidebarOpen: !state.sidebarOpen,
      };

    case UI_TYPES.SET_CURRENT_DATE:
      return {
        ...state,
        currentDate: action.payload,
      };

    default:
      return state;
  }
}
